export const P = {
  black:'#000000',water:'#080d54',green:'#49e63c',lime:'#c2f05c',darkGreen:'#165b25',
  white:'#f4f5db',yellow:'#f7e539',red:'#ef423c',orange:'#f38a3f',purple:'#a54eb5',
  median:'#683a76',blue:'#46bff1',log:'#a96b38',logLight:'#d6a35d',logDark:'#684126',
} as const;
